import { httpsCallable } from '../firebase';

export const updateUserStatus = httpsCallable<{ uid: string; nextStatus: 'enable' | 'disable' }, boolean>('updateUserStatus');
